const CONVERT_MAP = {
    "ガ": "ｶﾞ",
    "ギ": "ｷﾞ",
    "グ": "ｸﾞ",
    "ゲ": "ｹﾞ",
    "ゴ": "ｺﾞ",
    "ザ": "ｻﾞ",
    "ジ": "ｼﾞ",
    "ズ": "ｽﾞ",
    "ゼ": "ｾﾞ",
    "ゾ": "ｿﾞ",
    "ダ": "ﾀﾞ",
    "ヂ": "ﾁﾞ",
    "ヅ": "ﾂﾞ",
    "デ": "ﾃﾞ",
    "ド": "ﾄﾞ",
    "バ": "ﾊﾞ",
    "ビ": "ﾋﾞ",
    "ブ": "ﾌﾞ",
    "ベ": "ﾍﾞ",
    "ボ": "ﾎﾞ",
    "パ": "ﾊﾟ",
    "ピ": "ﾋﾟ",
    "プ": "ﾌﾟ",
    "ペ": "ﾍﾟ",
    "ポ": "ﾎﾟ",
    "ヴ": "ｳﾞ",
    "ヷ": "ﾜﾞ",
    "ヺ": "ｦﾞ",
    "ア": "ｱ",
    "イ": "ｲ",
    "ウ": "ｳ",
    "エ": "ｴ",
    "オ": "ｵ",
    "カ": "ｶ",
    "キ": "ｷ",
    "ク": "ｸ",
    "ケ": "ｹ",
    "コ": "ｺ",
    "サ": "ｻ",
    "シ": "ｼ",
    "ス": "ｽ",
    "セ": "ｾ",
    "ソ": "ｿ",
    "タ": "ﾀ",
    "チ": "ﾁ",
    "ツ": "ﾂ",
    "テ": "ﾃ",
    "ト": "ﾄ",
    "ナ": "ﾅ",
    "ニ": "ﾆ",
    "ヌ": "ﾇ",
    "ネ": "ﾈ",
    "ノ": "ﾉ",
    "ハ": "ﾊ",
    "ヒ": "ﾋ",
    "フ": "ﾌ",
    "ヘ": "ﾍ",
    "ホ": "ﾎ",
    "マ": "ﾏ",
    "ミ": "ﾐ",
    "ム": "ﾑ",
    "メ": "ﾒ",
    "モ": "ﾓ",
    "ヤ": "ﾔ",
    "ユ": "ﾕ",
    "ヨ": "ﾖ",
    "ラ": "ﾗ",
    "リ": "ﾘ",
    "ル": "ﾙ",
    "レ": "ﾚ",
    "ロ": "ﾛ",
    "ワ": "ﾜ",
    "ヲ": "ｦ",
    "ン": "ﾝ",
    "ァ": "ｧ",
    "ィ": "ｨ",
    "ゥ": "ｩ",
    "ェ": "ｪ",
    "ォ": "ｫ",
    "ッ": "ｯ",
    "ャ": "ｬ",
    "ュ": "ｭ",
    "ョ": "ｮ",
    "￥": "¥",
    "，": ",",
    "．": ".",
    "ー": "-",
    "－": "-",
    "「": "｢",
    "」": "｣",
    "（": "(",
    "）": ")",
    "‐": "-",
    "／": "/",
    "　": " "
};
const convertFullToHalf = (str) => {
    let result = str;
    result = convertFullAlphanumericToHalf(result);
    result = convertHiraganaToKatakana(result);
    result = convertFullKatakanaToHalf(result);
    return result;
};
// 全角カタカナ → 半角カタカナ
const convertFullKatakanaToHalf = (str) => {
    if (!str) {
        return "";
    }
    let result = str;
    for (const [full, half] of Object.entries(CONVERT_MAP)) {
        result = result.replace(new RegExp(full, "g"), half);
    }
    return result;
};
// ひらがな → 全角カタカナ
const convertHiraganaToKatakana = (str) => {
    if (!str) {
        return "";
    }
    return str.replace(/[\u3041-\u3096]/g, s => {
        return String.fromCharCode(s.charCodeAt(0) + 0x60);
    });
};
// 全角英数字 → 半角英数字
const convertFullAlphanumericToHalf = (str) => {
    if (!str) {
        return "";
    }
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, s => {
        return String.fromCharCode(s.charCodeAt(0) - 65248);
    });
};
// 半角英数字 → 全角英数字
const convertHalfAlphanumericToFull = (str) => {
    if (!str) {
        return "";
    }
    return str.replace(/[A-Za-z0-9]/g, s => {
        return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
    });
};
export { convertFullToHalf, convertFullAlphanumericToHalf, convertHalfAlphanumericToFull };
